import { render, staticRenderFns } from "./ChatVideosReveals.vue?vue&type=template&id=907b1946&"
import script from "./ChatVideosReveals.vue?vue&type=script&lang=js&"
export * from "./ChatVideosReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports